import Privilege from "../../entities/privilege";

/**
 * Privilege actions
 *
 * Call order:
 *
 * PRIVILEGE_SAVE_QUEUE:	adds the item to the save queue
 * --> PRIVILEGE_SAVE:	modifies the state
 * --> PRIVILEGE_SAVE_SUCCESS: if all went well
 * --> PRIVILEGE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail PRIVILEGE_SAVE_QUEUE is during the call to PRIVILEGE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const PRIVILEGE_FETCH_ONE_QUEUE: any = 'PRIVILEGE_FETCH_ONE_QUEUE';
export const PRIVILEGE_FETCH_SUCCESS: any = 'PRIVILEGE_FETCH_SUCCESS';
export const PRIVILEGE_FETCH_FAILURE: any = 'PRIVILEGE_FETCH_FAILURE';
export const PRIVILEGE_FETCH_ONE_SUCCESS: any = 'PRIVILEGE_FETCH_ONE_SUCCESS';
export const PRIVILEGE_FETCH_ONE_FAILURE: any = 'PRIVILEGE_FETCH_ONE_FAILURE';

export const PRIVILEGE_SAVE: any = 'PRIVILEGE_SAVE';
export const PRIVILEGE_SAVE_QUEUE: any = 'PRIVILEGE_SAVE_QUEUE';
export const PRIVILEGE_SAVE_SUCCESS: any = 'PRIVILEGE_SAVE_SUCCESS';
export const PRIVILEGE_SAVE_FAILURE: any = 'PRIVILEGE_SAVE_FAILURE';

export const PRIVILEGE_SAVE_MANY: any = 'PRIVILEGE_SAVE_MANY';
export const PRIVILEGE_SAVE_MANY_QUEUE: any = 'PRIVILEGE_SAVE_MANY_QUEUE';
export const PRIVILEGE_SAVE_MANY_SUCCESS: any = 'PRIVILEGE_SAVE_MANY_SUCCESS';
export const PRIVILEGE_SAVE_MANY_FAILURE: any = 'PRIVILEGE_SAVE_MANY_FAILURE';

export const PRIVILEGE_REMOVE: any = 'PRIVILEGE_REMOVE';
export const PRIVILEGE_REMOVE_QUEUE: any = 'PRIVILEGE_REMOVE_QUEUE';
export const PRIVILEGE_REMOVE_SUCCESS: any = 'PRIVILEGE_REMOVE_SUCCESS';
export const PRIVILEGE_REMOVE_FAILURE: any = 'PRIVILEGE_REMOVE_FAILURE';

export const PRIVILEGE_RESTORE: any = 'PRIVILEGE_RESTORE';
export const PRIVILEGE_RESTORE_QUEUE: any = 'PRIVILEGE_RESTORE_QUEUE';
export const PRIVILEGE_RESTORE_SUCCESS: any = 'PRIVILEGE_RESTORE_SUCCESS';
export const PRIVILEGE_RESTORE_FAILURE: any = 'PRIVILEGE_RESTORE_FAILURE';

export const PRIVILEGE_RESTORE_MANY: any = 'PRIVILEGE_RESTORE_MANY';
export const PRIVILEGE_REMOVE_MANY: any = 'PRIVILEGE_REMOVE_MANY';

/* Fetch actions */
export const fetchPrivilegeSuccess = (privileges: Privilege[], partial: boolean, lastFetch: number) => ({type: PRIVILEGE_FETCH_SUCCESS, privileges, partial, lastFetch});
export const fetchPrivilegeFailure = (err: any) => {
		console.error('PrivilegeAction: fetchPrivilegeFailure', err);
		return {type: PRIVILEGE_FETCH_FAILURE, err};
};
export const fetchOnePrivilegeQueue = (privilegeId: string) => ({type: PRIVILEGE_FETCH_ONE_QUEUE, privilegeId});
export const fetchOnePrivilegeSuccess = (privilege: Privilege) => ({type: PRIVILEGE_FETCH_ONE_SUCCESS, privilege});
export const fetchOnePrivilegeFailure = (id: string, err: any) => {
		console.error('PrivilegeAction: fetchOnePrivilegeFailure', err);
		return {type: PRIVILEGE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const savePrivilege = (privilege: Privilege) => {
    // console.debug('⮂ PRIVILEGE_SAVE action', privilege?.id);
    return {type: PRIVILEGE_SAVE, privilege};
}
export const savePrivilegeQueue = (privilege: Privilege, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ PRIVILEGE_SAVE_QUEUE action', privilege?.id);
    return {type: PRIVILEGE_SAVE_QUEUE, privilege, onQueued};
}
export const savePrivilegeSuccess = (privilege: Privilege) => {
    // console.debug('⮂ PRIVILEGE_SAVE_SUCCESS action', privilege?.id);
    return {type: PRIVILEGE_SAVE_SUCCESS, privilege};
}
export const savePrivilegeFailure = (privilege: Privilege, status: number, message: string) => {
    console.warn(`⮂ PRIVILEGE_SAVE_FAILURE error saving privilege: HTTP ${status}: ${message}`, privilege?.id);
    return {type: PRIVILEGE_SAVE_FAILURE, privilege, status, message};
};

/* SaveMany actions */
export const saveManyPrivileges = (privileges: Privilege[]) => {
    // console.debug('⮂ PRIVILEGE_SAVE_MANY action', privileges?.map(privilege => privilege?.id).join(','));
    return {type: PRIVILEGE_SAVE_MANY, privileges};
}
export const saveManyPrivilegesQueue = (privileges: Privilege[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ PRIVILEGE_SAVE_MANY_QUEUE action', privileges?.map(privilege => privilege.id).join(','));
    return {type: PRIVILEGE_SAVE_MANY_QUEUE, privileges, onQueued};
}

export const saveManyPrivilegesSuccess = (privileges: Privilege[]) => {
    // console.debug('⮂ PRIVILEGE_SAVE_MANY_SUCCESS action', privileges?.map(privilege => privilege.id).join(','));
    return {type: PRIVILEGE_SAVE_MANY_SUCCESS, privileges};
}
export const saveManyPrivilegesFailure = (privileges: Privilege[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_PRIVILEGES_FAILURE Error saving privileges: HTTP ${status}: ${message}`, privileges?.map(privilege => privilege.id).join(','));
		return {type: PRIVILEGE_SAVE_MANY_FAILURE, privileges, status, message};
};

/* Remove actions */
export const removePrivilege = (privilege: Privilege) => ({ type: PRIVILEGE_REMOVE, privilege });
export const removePrivilegeQueue = (privilege: Privilege) => ({ type: PRIVILEGE_REMOVE_QUEUE, privilege });
export const removePrivilegeSuccess = (privilege: Privilege) => ({ type: PRIVILEGE_REMOVE_SUCCESS, privilege });
export const removePrivilegeFailure = (privilege: Privilege, status: number, message: string) => {
	console.error(`Redux: removePrivilegeFailure Error removing privilege: HTTP ${status}: ${message}`);
	return ({ type: PRIVILEGE_REMOVE_FAILURE, privilege, status, message });
};

/* Restore actions */
export const restorePrivilege = (privilege: Privilege) => ({ type: PRIVILEGE_RESTORE, privilege });
export const restorePrivilegeQueue = (privilege: Privilege) => ({ type: PRIVILEGE_RESTORE_QUEUE, privilege });
export const restorePrivilegeSuccess = (privilege: Privilege) => ({ type: PRIVILEGE_RESTORE_SUCCESS, privilege });
export const restorePrivilegeFailure = (privilege: Privilege, status: number, message: string) => {
	console.error(`Redux: restorePrivilegeFailure Error restoring privilege: HTTP ${status}: ${message}`);
	return ({ type: PRIVILEGE_RESTORE_FAILURE, privilege, status, message });
};

/* RestoreMany actions */
export const restoreManyPrivileges = (privileges: Privilege[]) => ({ type: PRIVILEGE_RESTORE_MANY, privileges });

/* RemoveMany actions */
export const removeManyPrivileges = (privileges: Privilege[]) => ({ type: PRIVILEGE_REMOVE_MANY, privileges });